import React, { useEffect, useState } from "react";
import "./Start_Quiz.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllQuiz } from "../../features/admin/common/Slice";
import { AllProgramList } from "../../features/admin/common/Slice";
import { startQuiz } from "../../features/admin/quiz/Slice";
import { Spinner, Modal } from "react-bootstrap";
import Lottie from "react-lottie";
import * as animationData from "./Timer.json";

const Start_Quiz = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeProgramId, setActiveProgramId] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [isStarting, setIsStarting] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const quizData = useSelector((state) => state.common.all_quiz || []);
  const quiz = quizData.find((q) => q.id === Number(id));

  const allPrograms = useSelector(
    (state) => state.common.all_program_list || [],
  );

  // Assume you have quiz_competition_id and sets in your quiz data
  // If not available, you may need to fetch more details or hardcode for now

  const handleStartQuiz = async () => {
    if (!quiz) return;

    setIsStarting(true);

    try {
      const payload = { quiz_id: Number(id) };

      const response = await dispatch(startQuiz(payload)).unwrap();

      // NEW: Check if already passed
      if (response?.data?.already_passed === true) {
        const userQuizId = response.data.user_quiz_id;
        navigate(`/result-page/${userQuizId}`);
        return;
      }

      const userQuizId = response?.data?.user_quiz_id;

      if (userQuizId) {
        setShowModal(true);

        setTimeout(() => {
          setShowModal(false);
          navigate(`/quiz-page/${userQuizId}`);
        }, 5000);
      } else {
        alert("Failed to start quiz.");
      }
    } catch (error) {
      console.error("Start Quiz Error:", error);
      alert(error?.message || "Failed to start quiz");
    } finally {
      setIsStarting(false);
    }
  };

  if (!quiz) {
    return <div className="text-center mt-5">Quiz not found</div>;
  }

  return (
    <section className="Start_Quiz">
      <div className="container-fluid p-0">
        <div className="row g-0">
          <div className="col-lg-2 col-md-2 col-sm-4">
            <div className="sidebar_section">
              <div className="sidebar_group">
                <h5 className="sidebar_title">Other Quizzes</h5>
                {quizData.map((q) => (
                  <p
                    key={q.id}
                    className={`sidebar_text ${
                      activeId === q.id ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveId(q.id);
                      navigate(`/start-quiz/${q.id}`);
                    }}
                  >
                    <span>
                      <FontAwesomeIcon icon={faArrowUp} />
                    </span>
                    {q.title}
                  </p>
                ))}
              </div>

              <div className="sidebar_group mt-4">
                <h5 className="sidebar_title">Our Courses</h5>
                {allPrograms.length > 0 ? (
                  allPrograms.map((program) => (
                    <p
                      key={program.id}
                      className={`sidebar_text ${
                        activeProgramId === program.id ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setActiveProgramId(program.id);
                        navigate(`/explore-program/${program.id}`);
                      }}
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={faArrowUp}
                          style={{ color: "#000" }}
                        />
                      </span>{" "}
                      {program.name}
                    </p>
                  ))
                ) : (
                  <p className="sidebar_text">No courses available.</p>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-7 col-md-7 col-sm-8 p-3">
            <h2 className="quiz_heading">{quiz.title}</h2>
            <p className="quiz_description">{quiz.subtitle}</p>

            <div className="instructions_box">
              <h4>Instructions:</h4>
              {quiz.description && (
                <div
                  className="quiz_desc"
                  dangerouslySetInnerHTML={{ __html: quiz.description }}
                />
              )}
            </div>

            <button
              className="start_quiz_btn w-100 mt-4"
              onClick={handleStartQuiz}
              disabled={isStarting}
            >
              {isStarting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Starting Quiz...
                </>
              ) : (
                "Start Quiz"
              )}
            </button>
          </div>

          <Modal show={showModal} centered className="get_ready_modal">
            <Modal.Body className="text-center">
              <div className="timer_lottie_holder">
                <Lottie className="timer_lottie" options={defaultOptions} />
              </div>
              <h5>Get Ready !!</h5>
              <p>Your quiz will start in shortly</p>
            </Modal.Body>
          </Modal>

          <div className="col-lg-3 col-md-3">
            <div className="ads_section">
              <div className="promo_card">
                <img
                  src="/assets/images/start_quiz/right-img3.jpeg"
                  alt="promo"
                  className="promo_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Start_Quiz;
